import { render, staticRenderFns } from "./yuwenlink.vue?vue&type=template&id=3aac86be&scoped=true"
import script from "./yuwenlink.vue?vue&type=script&lang=js"
export * from "./yuwenlink.vue?vue&type=script&lang=js"
import style0 from "./yuwenlink.vue?vue&type=style&index=0&id=3aac86be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aac86be",
  null
  
)

export default component.exports